module.exports = __webpack_public_path__ + "static/media/Altendorf_WA_80_Brochure_English.ba7b9b13.pdf";